var Handlebars = require("../../../../handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "aria-expanded=\"true\"";
},"3":function(container,depth0,helpers,partials,data) {
    return "class=\"collapsed\"";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <!-- <i class=\"fa fa-circle-o-notch fa-spin\"></i> -->\n          <span class=\"search-progress\"><span>.</span><span>.</span><span>.</span></span>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"totalResults") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":10},"end":{"line":11,"column":17}}})) != null ? stack1 : "");
},"6":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            ("
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"hasLoaded") : depth0), depth0))
    + "/"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"totalResults") : depth0), depth0))
    + ")\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"hasError") : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.program(11, data, 0),"data":data,"loc":{"start":{"line":13,"column":10},"end":{"line":21,"column":17}}})) != null ? stack1 : "");
},"9":function(container,depth0,helpers,partials,data) {
    return "            <i class=\"fa fa-exclamation text-danger\"></i>\n";
},"11":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"hasMore") : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.program(14, data, 0),"data":data,"loc":{"start":{"line":16,"column":12},"end":{"line":20,"column":19}}})) != null ? stack1 : "");
},"12":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              ("
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"hasLoaded") : depth0), depth0))
    + "/"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"totalResults") : depth0), depth0))
    + ")\n";
},"14":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              ("
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"totalResults") : depth0), depth0))
    + ")\n";
},"16":function(container,depth0,helpers,partials,data) {
    return "<span class=\"caret\"></span>";
},"18":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<a target=\"_blank\" href=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"searchRequest") : depth0)) != null ? lookupProperty(stack1,"url") : stack1), depth0))
    + "\"><i class=\"fa fa-external-link\"></i></a>";
},"20":function(container,depth0,helpers,partials,data) {
    return "in";
},"22":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isSearching") : depth0),{"name":"if","hash":{},"fn":container.program(23, data, 0),"inverse":container.program(25, data, 0),"data":data,"loc":{"start":{"line":30,"column":6},"end":{"line":38,"column":13}}})) != null ? stack1 : "")
    + "      <div class=\"panel-body\">\n        <div class=\"spacer spacer-top\"/>\n        <ul id=\"result-list-"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"layerId") : depth0), depth0))
    + "\" class=\"result-list list-inline list-unstyled\"></ul>\n        <div class=\"spacer spacer-bottom\"/>\n      </div>\n";
},"23":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <button class=\"btn btn-sm btn-default btn-block btn-load-more\" type=\"button\" disabled>"
    + container.escapeExpression(__default(require("../../../../../src/helpers/t.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Searching",(depth0 != null ? lookupProperty(depth0,"countLoadMore") : depth0),{"name":"t","hash":{},"data":data,"loc":{"start":{"line":31,"column":94},"end":{"line":31,"column":126}}}))
    + "<span class=\"search-progress\"><span>.</span><span>.</span><span>.</span></span></button>\n";
},"25":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"hasMore") : depth0),{"name":"if","hash":{},"fn":container.program(26, data, 0),"inverse":container.program(28, data, 0),"data":data,"loc":{"start":{"line":32,"column":6},"end":{"line":38,"column":6}}})) != null ? stack1 : "");
},"26":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <button class=\"btn btn-sm btn-default btn-block btn-load-more\" type=\"button\">"
    + container.escapeExpression(__default(require("../../../../../src/helpers/t.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"load_more",(depth0 != null ? lookupProperty(depth0,"countLoadMore") : depth0),{"name":"t","hash":{},"data":data,"loc":{"start":{"line":33,"column":85},"end":{"line":33,"column":116}}}))
    + "</button>\n";
},"28":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"totalResults") : depth0),{"name":"if","hash":{},"fn":container.program(29, data, 0),"inverse":container.program(31, data, 0),"data":data,"loc":{"start":{"line":34,"column":6},"end":{"line":38,"column":6}}})) != null ? stack1 : "");
},"29":function(container,depth0,helpers,partials,data) {
    return "        <button class=\"btn btn-sm btn-default btn-block btn-load-more\" type=\"button\" disabled>"
    + container.escapeExpression(__default(require("../../../../../src/helpers/t.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"No more records",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":35,"column":94},"end":{"line":35,"column":117}}}))
    + "</button>\n";
},"31":function(container,depth0,helpers,partials,data) {
    return "        <button class=\"btn btn-sm btn-default btn-block btn-load-more\" type=\"button\" disabled>"
    + container.escapeExpression(__default(require("../../../../../src/helpers/t.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Search returned no results",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":37,"column":94},"end":{"line":37,"column":128}}}))
    + "</button>\n      ";
},"33":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div class=\"panel-body\" style=\"color: white\">"
    + container.escapeExpression(__default(require("../../../../../src/helpers/t.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"errorMessage") : depth0),{"name":"t","hash":{},"data":data,"loc":{"start":{"line":45,"column":51},"end":{"line":45,"column":69}}}))
    + "</div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"panel panel-default\">\n  <div class=\"panel-heading\" role=\"tab\">\n    <h4 class=\"panel-title\">\n      <a role=\"button\" data-toggle=\"collapse\" href=\"#collapse-"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"layerId") : depth0), depth0))
    + "\" "
    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"isClosed") : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":4,"column":75},"end":{"line":4,"column":151}}})) != null ? stack1 : "")
    + ">\n        "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"layerName") : depth0), depth0))
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isSearching") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.program(8, data, 0),"data":data,"loc":{"start":{"line":6,"column":8},"end":{"line":22,"column":15}}})) != null ? stack1 : "")
    + "        "
    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"isSearching") : depth0),{"name":"unless","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":8},"end":{"line":23,"column":69}}})) != null ? stack1 : "")
    + "\n        "
    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"hasError") : depth0),{"name":"unless","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":8},"end":{"line":24,"column":126}}})) != null ? stack1 : "")
    + "\n      </a>\n    </h4>\n  </div>\n  <div id=\"collapse-"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"layerId") : depth0), depth0))
    + "\" class=\"panel-collapse panel-result-list collapse "
    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"isClosed") : depth0),{"name":"unless","hash":{},"fn":container.program(20, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":28,"column":82},"end":{"line":28,"column":115}}})) != null ? stack1 : "")
    + "\" role=\"tabpanel\">\n"
    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"hasError") : depth0),{"name":"unless","hash":{},"fn":container.program(22, data, 0),"inverse":container.program(33, data, 0),"data":data,"loc":{"start":{"line":29,"column":4},"end":{"line":46,"column":15}}})) != null ? stack1 : "")
    + "  </div>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// /~/eoxc/src/search/views/SearchResultListView.hbs
// module id = 2053
// module chunks = 0